
import PlayablePreviewer from '@pt/components/playablePreviewer.vue';
import PreviewerSwitcher from '@pt/components/creative-previewer/previewerSwitcher.vue';

export default {
  components: {
    PlayablePreviewer: PlayablePreviewer,
    PreviewerSwitcher: PreviewerSwitcher
  },
  props: {
    currentDcoList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    material: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      list: [], // 图片资源列表
      textList: [], // 文本资源列表
      videoList: [], // 视频资源列表
      listLoading: false,
      activeName: 'image',
      currentDco: '',
      currentItem: {}
    };
  },

  methods: {
    handleChange: function handleChange(id) {
      var selected = this.innerDcoList.find(function (item) {
        return item.id === id;
      });
      this.currentItem = selected;
    },
    initViwer: function initViwer() {
      if (!this.currentDcoList.length) return;
      // reset asset list
      this.list = [];

      // const url = this.currentDcoList[0].preview_url
      this.currentItem = this.innerDcoList.length ? this.innerDcoList[0] : {};
    }
  },
  mounted: function mounted() {
    this.initViwer();
  },

  computed: {
    currentPreviewUrl: function currentPreviewUrl() {
      console.log('变化');
      if (this.currentItem && this.currentItem.preview_url) {
        var tempUrl = this.currentItem.preview_url.replace('http:', 'https:'); // 更换https地址
        var hasQuery = tempUrl.indexOf('?') !== -1;
        return '' + tempUrl + (hasQuery ? '&' : '?') + 'dco_gid=' + this.currentItem.gid + '&preview=true&loading=1';
      }
      return '';
    },
    innerDcoList: function innerDcoList() {
      var _this = this;

      if (!this.currentDcoList.length) return [];
      var groups = this.currentDcoList[0].groups ? JSON.parse(this.currentDcoList[0].groups) : [];
      var list = this.material.creative_type === 'video' ? this.currentDcoList : groups;
      return list.map(function (item) {
        var uniId = _this.material.creative_type === 'video' ? item.gid + '-' + item.resolution : item.gid;
        return {
          // 视频dco有多个尺寸，拼接id需要加上resolution
          id: uniId,
          gid: item.gid,
          name: '\u7EC4\u5408: ' + item.gid,
          label: '\u7EC4\u5408: ' + uniId,
          preview_url: _this.material.creative_type === 'video' ? item.creative_url : _this.currentDcoList[0].preview_url

        };
      });
    }
  },
  watch: {
    'currentDcoList': function currentDcoList(val) {
      if (val.length) {
        this.initViwer();
      }
    }
  }
};